import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: 'Neue {{method}} Bestellung!',
        scheduled: 'Geplante {{method}} Bestellung!',
      },
      labels: {
        today: 'heute',
        time_remaining_to_accept: 'noch zu akzeptieren',
      },
      time_tag: {
        asap: '🕓 Abholung um {{time}}',
        scheduled: '🕓 Abholung am {{day}} um {{time}}',
      },
      time_tag_estimated: {
        asap: '🕓 Ungefähre Abholzeit: {{time}}',
        scheduled: '🕓 Ungefähre Abholzeit: {{day}} um {{time}}',
      },
      buttons: {
        confirm_order: 'Bestellung bestätigen',
        cancel_order: 'Bestellung stornieren',
      },
      feedback: {
        rough_estimate_warning:
          'Dies ist nur eine grobe Schätzung. Die tatsächliche Vorbereitungszeit erhältst du, sobald ein Fahrer zugewiesen und die Lieferzeit bestätigt wurde. Zu diesem Zeitpunkt wird dein Ticket automatisch ausgedruckt.',
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Vorbereitungszeit',
      labels: {
        today: 'Today',
        order_time: {
          delivery: {
            asap: 'Lieferung in',
            scheduled: 'Lieferung am',
          },
          other: {
            asap: 'Abholung in',
            scheduled: 'Abholung am',
          },
        },
        can_you_make_it: 'Schaffst du das?',
        we_also_send_this_update_to_the_customer: 'Wir senden dieses Update auch an den Kunden.',
      },
      buttons: {
        yes_lets_go: "Ja, los geht's!",
        no_change_time: 'Nein, Zeit ändern',
        confirm: 'Bestätigen',
      },
      toasts: {
        order_confirmed: {
          title: 'Bestellung #{{number}} bestätigt',
          body: 'Noch nicht vorbereiten – wir melden uns, sobald ein Fahrer zugewiesen ist.',
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          'Leider muss die Lieferung storniert werden, da der Fahrer nicht verfügbar ist. Klicke oben rechts auf die drei Punkte, um die Bestellung zu stornieren und dem Kunden das Geld zurückzuerstatten.',
        [BackendErrorCode.DeliveryProviderException]:
          'Leider muss die Lieferung storniert werden, da der Fahrer nicht verfügbar ist. Klicke oben rechts auf die drei Punkte, um die Bestellung zu stornieren und dem Kunden das Geld zurückzuerstatten.',
      },
    },
  },
};
